import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/receipt-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/bus-round-front-outline-grey.svg'
import _imports_2 from '@/assets/img/icon/eye-background-blue.svg'


const _hoisted_1 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Informasi Batch", -1)
const _hoisted_3 = {
  key: 0,
  class: "chip-primary-outline"
}
const _hoisted_4 = {
  key: 1,
  class: "chip-primary-outline"
}
const _hoisted_5 = {
  key: 2,
  class: "chip-purple-outline"
}
const _hoisted_6 = {
  key: 3,
  class: "chip-green-outline"
}
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Kode Batch:", -1)
const _hoisted_10 = { class: "font-bold col-span-2" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3 mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Tanggal Dibuat:", -1)
const _hoisted_13 = { class: "font-bold col-span-2" }
const _hoisted_14 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 gap-3 col mb-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Nama User:", -1)
const _hoisted_16 = { class: "font-bold col-span-2" }
const _hoisted_17 = { class: "border-primary rounded-lg py-4 grid grid-cols-2" }
const _hoisted_18 = { class: "border-right-grey-lighten-3 pl-4 pr-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Jumlah Transaksi", -1)
const _hoisted_20 = { class: "text-base font-bold" }
const _hoisted_21 = {
  key: 0,
  class: "text-primary text-base font-bold"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "pl-2 pr-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Total", -1)
const _hoisted_26 = { class: "text-base font-bold" }
const _hoisted_27 = { class: "flex justify-between mb-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-xl" }, "Daftar Transaksi"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base text-grey font-semibold" }, "Daftar transaksi pengisian BBM yang masuk dalam batch ini")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "receipt"
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, "Detail Pembayaran", -1)
const _hoisted_31 = { class: "flex items-center justify-between mb-4" }
const _hoisted_32 = { class: "flex items-center gap-4" }
const _hoisted_33 = { class: "flex items-center gap-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Filter:", -1)
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = { class: "fuel-payment-batch-detail-table" }
const _hoisted_37 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "TANGGAL"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "KODE"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "POM"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "KRU - NOPOL"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "JENIS TRANSAKSI"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-xs text-left",
      style: {"width":"50px"}
    }, "LITER"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "NOMINAL"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "AKSI")
  ])
], -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak ada data transaksi")
], -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-grey mr-1" }, null, -1)
const _hoisted_45 = { class: "flex items-center gap-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { style: {"width":"50px"} }
const _hoisted_49 = {
  key: 0,
  style: {"width":"100px"}
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  style: {"width":"150px"}
}
const _hoisted_52 = { class: "flex items-center gap-3" }
const _hoisted_53 = {
  key: 0,
  class: "chip-grey-outline w-100px"
}
const _hoisted_54 = {
  key: 1,
  class: "chip-green-outline"
}
const _hoisted_55 = {
  key: 2,
  class: "mx-1"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 2,
  style: {"width":"225px"}
}
const _hoisted_58 = { class: "flex items-center gap-3" }
const _hoisted_59 = {
  key: 0,
  class: "chip-grey-outline w-100px"
}
const _hoisted_60 = {
  key: 1,
  class: "chip-purple-outline"
}
const _hoisted_61 = {
  key: 2,
  class: "chip-purple-outline"
}
const _hoisted_62 = {
  key: 3,
  class: "chip-green-outline"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "mx-1" }, "|", -1)
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  key: 3,
  style: {"width":"225px"}
}
const _hoisted_66 = { class: "flex items-center gap-3" }
const _hoisted_67 = {
  key: 0,
  class: "chip-green-outline"
}
const _hoisted_68 = {
  key: 1,
  class: "chip-purple-outline"
}
const _hoisted_69 = {
  key: 2,
  class: "chip-purple-outline"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "mx-1" }, "|", -1)
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Transaksi terverifikasi", -1)
const _hoisted_74 = { class: "text-base font-bold text-primary" }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Transaksi direvisi", -1)
const _hoisted_77 = { class: "text-base font-bold text-primary" }
const _hoisted_78 = { class: "flex items-center justify-end" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, /*#__PURE__*/_toDisplayString('Alasan Transaksi Tidak Sesuai'), -1)

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import moment from 'moment'
import Card from 'primevue/card'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import '../detail-table.scss'
import numberFormat from '@/utils/helpers/numberFormat'
import Paginator from '@/views/components/paginator/Paginator.vue'
import Button from 'primevue/button'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import OverlayPanel from 'primevue/overlaypanel'
import Popper from 'vue3-popper'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import { checkActionAllowedRoles } from '@/utils/helpers/checkActionAllowedRoles'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import TransactionDetail from '../components/TransactionDetail.vue'
import DetailListActions from '../components/DetailListActions.vue'
import PendingPage from '../components/PendingPage.vue'
import FinanceRefundForm from '../components/FinanceRefundForm.vue'
import BatchPaymentDetail from '../components/BatchPaymentDetail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const endpoint = 'transaction/v2/FuelingTransactions'
const endpointBatch = 'transaction/v2/FuelingPaymentBatches'
const backRouteName = 'fuel-payment-batch'
const filterStorageKey = 'fuel-payment-batch-detail-filters'
const store = useStore()
const route = useRoute()
const router = useRouter()
const headerData = ref()
const dataSource = ref([]) as any
const inputSearch = ref('')
const isShowConfirmVerifyCheckerDialog = ref(false)
const isShowConfirmVerifyFinanceDialog = ref(false)
const isShowConfirmPaymentDialog = ref(false)
const isShowDetailPaymentDialog = ref(false)
const selectedRowData = ref(null) as any
const app = getCurrentInstance()
const refOverlayAction = ref()
const selectedDetailRowData = ref(null) as any
const isShowCheckerPendingDialog = ref(false)
const origin = ref(null) as any
const transactionOptions = ref([{ label: 'Semua', value: '' }]) as any
const verifiedList = computed(() => store.state.fuelPaymentBatch.verifiedTransactionList)
const selectedTransactionOption = ref(null) as any
const isShowFinanceRefundForm = ref(false)
const refundDataCount = ref(0)
const {
  $icon,
  $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const filterDate = ref()
const today = new Date()
filterDate.value = []
const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  custom: [] as any,
  totalRecords: 0
})

onBeforeRouteLeave((to) => {
  if (to.name === 'fuel-payment-batch-transaction-detail') {
    sessionStorage.setItem(filterStorageKey, JSON.stringify({
      batchId: headerData.value?.Id,
      filters: filters.value,
      filterDate: filterDate.value
    }))
  } else {
    sessionStorage.removeItem(filterStorageKey)
  }
})

const confirmPaymentDialog = ref({
  show: false,
  title: 'Bayar Tagihan?',
  subTitle: '',
  subTitleHtml: true,
  btnSubmitTitle: 'Lanjut Pembayaran',
  imgContent: require('@/assets/img/modal-confirmation/make-payment.png')
})

const confirmVerifyCheckerDialog = ref({
  show: false,
  title: 'Simpan Verifikasi?',
  subTitle: '',
  subTitleHtml: true,
  btnSubmitTitle: 'Simpan Verifikasi',
  imgContent: require('@/assets/img/modal-confirmation/payment-batch.svg')
})

const confirmVerifyFinanceDialog = ref({
  show: false,
  title: 'Simpan Revisi?',
  subTitle: '',
  subTitleHtml: true,
  btnSubmitTitle: 'Simpan Revisi',
  imgContent: require('@/assets/img/modal-confirmation/payment-batch.svg')
})

const getTransactionTypeLabel = (name: string) => {
  if (name) {
    const nameSet = name.toLowerCase()
    if (nameSet === 'voucher') return 'Kupon BBM'
    if (nameSet === 'scanhjcrew') return 'Scan Aplikasi'
  }
  return name
}

const getDetailData = async () => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.get(`${endpoint}${returnUrlPrams(filters.value)}`).then((response) => {
      const { error, result, count } = response
      if (!error) {
        dataSource.value = result
        filters.value.totalRecords = count
        refundDataCount.value = dataSource.value.filter((item: any) => item.TransactionType === 'Refund').length
      }
    })
  } catch (error) {
    console.log('error', error)
  }
  store.dispatch('hideLoading')
}

const onChangePage = (evt: any) => {
  // console.log('evt', evt)
  filters.value.pageNumber = evt.page + 1
  getDetailData()
}

const backPage = () => {
  router.push(({
    name: backRouteName
  }))
}

const submitFromPaymentDialog = async () => {
  // console.log('submit')
  store.dispatch('showLoading')
  try {
    const payload = {}
    await apiUseCase.postWithNoId(`${endpointBatch}/${headerData.value?.Id}/MarkPaid`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Pembayaran berhasil',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        hideConfirmPaymentDialog()
        backPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal melakukan pembayaran',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal melakukan pembayaran',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const showConfirmPaymentDialog = () => {
  // console.log('headerData', headerData.value)
  confirmPaymentDialog.value.subTitle = `Tagihan <span class="font-bold">${headerData.value?.Code}</span> sebesar <span class="font-bold">${rupiahFormat(headerData.value?.TotalAmount ?? 0)}</span> akan dibayarkan ke <span class="font-bold">${headerData.value?.FuelStationPartnerName ?? '-'}</span>. Lanjutkan pembayaran?`
  isShowConfirmPaymentDialog.value = true
}

const hideConfirmPaymentDialog = () => {
  isShowConfirmPaymentDialog.value = false
}

const showConfirmVerifyCheckerDialog = () => {
  // console.log('headerData', headerData.value)
  confirmVerifyCheckerDialog.value.subTitle = `Transaksi dalam <span class="font-bold">${headerData.value.Code}</span> telah diverifikasi oleh checker <span class="font-bold">${verifiedList.value.length}/${headerData.value.TotalTransaction} Nota</span>. Simpan hasil verifikasi?`
  isShowConfirmVerifyCheckerDialog.value = true
}

const showConfirmVerifyFinanceDialog = () => {
  // console.log('headerData', headerData.value)
  confirmVerifyFinanceDialog.value.subTitle = `Transaksi dalam <span class="font-bold">${headerData.value.Code}</span> telah direvisi oleh keuangan <span class="font-bold">${verifiedList.value.length} Nota</span>. Simpan hasil revisi?`
  isShowConfirmVerifyFinanceDialog.value = true
}

const hideConfirmVerifyCheckerDialog = () => {
  isShowConfirmVerifyCheckerDialog.value = false
}

const hideConfirmVerifyFinanceDialog = () => {
  isShowConfirmVerifyFinanceDialog.value = false
}

const showDetailPaymentDialog = () => {
  isShowDetailPaymentDialog.value = true
}

const hideDetailPaymentDialog = () => {
  isShowDetailPaymentDialog.value = false
}

const checkerVerificationAct = async () => {
  const payload = verifiedList.value
  // const payloadTemp = dataSource.value.filter((item: any) => item.TransactionType === 'Refund').map((itemMap: any) => (
  //   payload.push({
  //     FuelingTransactionId: itemMap.Id,
  //     Status: 'Completed',
  //     Notes: ''
  //   })
  // ))
  // console.log('payloadTemp', payloadTemp)
  // console.log('payload', payload)
  store.dispatch('showLoading')
  try {
    await apiUseCase.postWithNoId(`${endpointBatch}/${headerData.value.Id}/CheckerVerification`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          summary: 'Verifikasi Berhasil',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // getDetailData()
        backPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal melakukan verifikasi',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal melakukan verifikasi',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const financeVerificationAct = async () => {
  const payload = verifiedList.value
  dataSource.value.filter((item: any) => item.ApprovalStatus === 'Completed').map((itemMap: any) => (
    store.dispatch('fuelPaymentBatch/pushVerifiedTransactionList', {
      FuelingTransactionId: itemMap.Id,
      Status: 'Completed',
      Notes: '',
      FuelingTransactionRevision: null
    })
  ))
  // console.log('payload', payload)
  store.dispatch('showLoading')
  try {
    await apiUseCase.postWithNoId(`${endpointBatch}/${headerData.value.Id}/FinanceVerification`, payload).then((response) => {
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          summary: 'Verifikasi Berhasil',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // getDetailData()
        backPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal melakukan verifikasi',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal melakukan verifikasi',
      detail: error,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const checkerConfirmAct = () => {
  console.log('confirm')
  // checkerVerificationAct(0)
  const data = {
    FuelingTransactionId: selectedDetailRowData.value.Id,
    Status: 'Completed',
    Notes: ''
  }
  store.dispatch('fuelPaymentBatch/pushVerifiedTransactionList', data)
  // eslint-disable-next-line no-use-before-define
  hideOverlay()
}

const checkerPendingSubmitAct = (notes: any) => {
  const data = {
    FuelingTransactionId: selectedDetailRowData.value.Id,
    Status: 'Pending',
    Notes: notes
  }
  store.dispatch('fuelPaymentBatch/pushVerifiedTransactionList', data)
  // eslint-disable-next-line no-use-before-define
  hideCheckerPendingDialog()
}

const financeRefundAct = (notes: any) => {
  console.log('hehe')
  isShowFinanceRefundForm.value = true
  // const data = {
  //   FuelingTransactionId: selectedDetailRowData.value.Id,
  //   Status: 'Refund',
  //   Note: notes
  // }
  // store.dispatch('fuelPaymentBatch/pushVerifiedTransactionList', data)
  // eslint-disable-next-line no-use-before-define
  hideOverlay()
}

const checkerPendingAct = () => {
  console.log('pending')
  // eslint-disable-next-line no-use-before-define
  showCheckerPendingDialog()
  // eslint-disable-next-line no-use-before-define
  hideOverlay()
}

const showDropDown = (evt: any, item: any) => {
  selectedDetailRowData.value = item
  refOverlayAction.value.toggle(evt)
}

const hideOverlay = () => {
  refOverlayAction.value.hide()
}

const checkIsVerifiedChecker = (id: any) => {
  const res = verifiedList.value.some((data: any) => data?.FuelingTransactionId === id)
  return res
}

const checkVerifiedCheckerStatus = (id: any) => {
  const res = verifiedList.value.find((data: any) => data?.FuelingTransactionId === id)
  // console.log('resX', res)
  return res?.Status
}

const getPendingNoteChecker = (id: any) => {
  const res = verifiedList.value.find((data: any) => data?.FuelingTransactionId === id)
  // console.log('resX', res)
  return res?.Note
}

const hideCheckerPendingDialog = () => {
  isShowCheckerPendingDialog.value = false
}

const showCheckerPendingDialog = () => {
  isShowCheckerPendingDialog.value = true
}

const checkerVerifyBatchAct = () => {
  // console.log('refundDataCount', refundDataCount)
  if (headerData.value.FuelingTransactionConfirmedCount === headerData.value.TotalTransaction) {
    checkerVerificationAct()
  } else {
    $toast.add({
      severity: 'error',
      summary: 'Verifikasi Semua Transaksi',
      detail: 'Pastikan semua transaksi diverifikasi sebelum klik Simpan.',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const financeVerifyBatchAct = () => {
  // console.log('refundDataCount', refundDataCount)
  if (headerData.value.FuelingTransactionConfirmedCount === headerData.value.TotalTransaction) {
    financeVerificationAct()
  } else {
    $toast.add({
      severity: 'error',
      summary: 'Revisi Semua Transaksi',
      detail: 'Pastikan semua transaksi direvisi sebelum klik Simpan.',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const onSearch = () => {
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  selectedDetailRowData.value = null
  selectedRowData.value = null
  getDetailData()
}

const applyDateFilter = (evt: any) => {
  const startIndex = filters.value.custom.findIndex((item: any) => item[0] === 'startDate')
  const endIndex = filters.value.custom.findIndex((item: any) => item[0] === 'endDate')

  if (startIndex !== -1) {
    filters.value.custom[startIndex][2] = moment(filterDate.value[0]).format('YYYY-MM-DD')
  } else {
    filters.value.custom.push(['startDate', '=', moment(filterDate.value[0]).format('YYYY-MM-DD')])
  }

  if (endIndex !== -1) {
    filters.value.custom[endIndex][2] = moment(filterDate.value[1]).format('YYYY-MM-DD')
  } else {
    filters.value.custom.push(['endDate', '=', moment(filterDate.value[1]).format('YYYY-MM-DD')])
  }
  filters.value.pageNumber = 1
  selectedDetailRowData.value = null
  selectedRowData.value = null
  getDetailData()
}

const onFilter = async () => {
  const findFilter = filters.value.custom.find((data: any) => data[0] === 'transactionTypes')
  filters.value.pageNumber = 1
  selectedDetailRowData.value = null
  selectedRowData.value = null
  if (!findFilter) {
    if (selectedTransactionOption.value.value !== '') {
      filters.value.custom.push(['transactionTypes', '=', selectedTransactionOption.value.value])
    } else {
      filters.value.custom = filters.value.custom.filter((data: any) => data[0] !== 'transactionTypes')
    }
    await getDetailData()
  } else {
    if (selectedTransactionOption.value.value !== '') {
      findFilter[2] = selectedTransactionOption.value.value
    } else {
      filters.value.custom = filters.value.custom.filter((data: any) => data[0] !== 'transactionTypes')
    }
    await getDetailData()
  }
}

const getTransactionOptions = () => {
  apiUseCase.get(`${endpoint}/TransactionTypes`).then((response) => {
    const { error, result } = response
    // console.log('result', result)
    if (!error) {
      // eslint-disable-next-line array-callback-return
      result.map((data: any) => {
        transactionOptions.value.push({
          label: data.Description,
          value: data.Name
        })
      })
      const selectedType = filters.value.custom.find((data: any) => data[0] === 'transactionTypes')?.[2] ?? ''
      selectedTransactionOption.value = transactionOptions.value.find((option: any) => option.value === selectedType) ?? transactionOptions.value[0]
    }
  })
}

const openDetail = (item: any) => {
  router.push({
    name: 'fuel-payment-batch-transaction-detail',
    params: { id: encryptDecriptMethods.encrypt({ batchData: headerData.value, Id: item.Id, origin: origin.value }) }
  })
}

const getHeaderData = (headerId: string) => {
  store.dispatch('showLoading')
  apiUseCase.get(`${endpointBatch}/${headerId}`).then((response) => {
    const { error, result } = response
    // console.log('res', result)
    if (!error) {
      // headerData.value = {
      //   ...headerData.value,
      //   FuelStationPartners: result.FuelStationPartners
      // }
      headerData.value = result
      store.dispatch('ui/setBreadcrumbs', [
        {
          title: 'Batch Pembayaran BBM',
          routeName: backRouteName
        },
        {
          title: `Detail Batch - ${headerData.value?.Code}`,
          routeName: `${backRouteName}-detail`,
          params: { id: encryptDecriptMethods.encrypt({ origin: origin.value, data: headerData.value }) }
        }
      ])
    }
    // console.log('headerData', headerData.value)
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  store.dispatch('fuelPaymentBatch/flushVerifiedTransactionList')
  const dataTemp = encryptDecriptMethods.decrypt(route.params.id)
  headerData.value = dataTemp.data
  getHeaderData(dataTemp.data?.Id)
  origin.value = dataTemp.origin
  const defaultCustomFilters = [['fuelingPaymentBatchId', '=', headerData.value?.Id], ['orderBy', '=', 'ApprovalStatus desc']]
  const savedFilterState = sessionStorage.getItem(filterStorageKey)
  let restoredFilters = false
  if (savedFilterState) {
    sessionStorage.removeItem(filterStorageKey)
    try {
      const savedState = JSON.parse(savedFilterState)
      if (savedState.batchId === headerData.value?.Id) {
        filters.value = savedState.filters
        filterDate.value = (savedState.filterDate ?? []).map((date: string | null) => (date ? new Date(date) : null))
        inputSearch.value = filters.value.search
        restoredFilters = true
      }
    } catch (error) {
      console.error('Unable to restore batch filters', error)
    }
  }
  if (!restoredFilters) {
    filters.value.custom = defaultCustomFilters
    filters.value.pageNumber = 1
    filters.value.search = ''
    inputSearch.value = ''
    filterDate.value = []
    selectedTransactionOption.value = null
  }
  getTransactionOptions()
  getDetailData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-list mb-4" }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (headerData.value?.Status === 'OnPayment' && !headerData.value?.IsCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(headerData.value?.StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (headerData.value?.Status === 'Paid' && !headerData.value?.IsCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(headerData.value?.StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (headerData.value?.Status === 'CompletedWithRefund')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(headerData.value?.StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (headerData.value?.Status === 'Completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(headerData.value?.StatusDisplayName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(headerData.value?.Code), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(headerData.value?.CreatedAt ? _unref(moment)(headerData.value?.CreatedAt).format('DD/MM/YYYY - HH:mm:ss') : '-'), 1)
              ]),
              (headerData.value?.UpdatedBy)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(headerData.value?.UpdatedBy ?? '-'), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    (headerData.value?.Status !== 'OnPayment')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(numberFormat)(headerData.value?.FuelingTransactionVerificationCount)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_22,
                    (headerData.value?.Status !== 'OnPayment')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " / "))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(`${_unref(numberFormat)(headerData.value?.TotalTransaction)} Nota`), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(rupiahFormat)(headerData.value?.TotalAmount ?? 0)), 1)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-list" }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", null, [
              _createVNode(_unref(Button), {
                class: "flex gap-2 extra-submit-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetailPaymentDialog())),
                outlined: true
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _hoisted_30
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(Calendar), {
                    modelValue: filterDate.value,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
                      _cache[2] || (_cache[2] = ($event: any) => (applyDateFilter($event)))
                    ],
                    selectionMode: "range",
                    dateFormat: "dd/mm/yy",
                    placeholder: "Tanggal",
                    class: "w-56"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode(_unref(Dropdown), {
                modelValue: _unref(selectedTransactionOption),
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedTransactionOption) ? (selectedTransactionOption).value = $event : null)),
                  onFilter
                ],
                options: _unref(transactionOptions),
                optionLabel: "label",
                placeholder: "Jenis Transaksi",
                class: "w-full md:w-14rem"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(InputIconRight, {
                class: "input-search-header-custom",
                placeholder: 'Cari kode transaksi',
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputSearch).value = $event)),
                canClick: true,
                icon: _unref(icon).svg.searchEva,
                onSubmitInput: onSearch,
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue", "icon", "onKeyup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("table", _hoisted_37, [
              _hoisted_38,
              (_unref(dataSource).length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, _hoisted_41))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
                      return (_openBlock(), _createElementBlock("tr", { key: data }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(data.CreatedAt ? _unref(moment)(data.CreatedAt).format('DD/MM/YYYY') : '-'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(data.Code ?? '-'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(data.FuelStationPartnerName ?? '-'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", null, _toDisplayString(data.CrewName ?? '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createElementVNode("div", null, _toDisplayString(data.VehicleRegNumber ?? '-'), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(getTransactionTypeLabel(data.TransactionType)), 1),
                          (data.FuelTransactionVoucher)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(data.FuelTransactionVoucher.Code), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(`${_unref(numberFormat)(data.Liters ?? 0)} L`), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(rupiahFormat)(data.Price ?? 0)), 1),
                        (_unref(origin) === 'onPayment')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                              (_unref(checkActionAllowedRoles)(['Admin', 'Keuangan']))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "text-sm text-primary cursor-pointer",
                                    onClick: ($event: any) => (openDetail(data))
                                  }, "Detail Transaksi >", 8, _hoisted_50))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(origin) === 'checker')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                (data.ApprovalStatus === 'Pending')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'Completed')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus !== 'Paid')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, "|"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: "detail",
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (openDetail(data))
                                }, null, 8, _hoisted_56)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(origin) === 'finance')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                (data.ApprovalStatus === 'Pending')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'Refund')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'RefundApproved')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'Completed')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_63,
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: "detail",
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (openDetail(data))
                                }, null, 8, _hoisted_64)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(origin) === 'completed')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                (data.ApprovalStatus === 'Completed')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'Refund')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                (data.ApprovalStatus === 'RefundApproved')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(data.ApprovalStatusDisplayName), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_70,
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: "detail",
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (openDetail(data))
                                }, null, 8, _hoisted_71)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
            ])
          ]),
          _createVNode(Paginator, {
            first: (filters.value.pageNumber - 1) * filters.value.pageSize,
            rows: filters.value.pageSize,
            totalRecords: filters.value.totalRecords,
            onOnPage: onChangePage
          }, null, 8, ["first", "rows", "totalRecords"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center", _unref(origin) !== 'checker' && _unref(origin) !== 'finance' ? 'justify-end' : 'justify-between'])
          }, [
            (_unref(origin) === 'checker')
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, _toDisplayString(`${headerData.value?.FuelingTransactionVerificationCount}/${headerData.value?.TotalTransaction} Transaksi terverifikasi`), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(origin) === 'finance')
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, _toDisplayString(`${headerData.value?.FuelingTransactionRevisionCount} Transaksi direvisi`), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (backPage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_79
                ]),
                _: 1
              })
            ])
          ], 2)
        ]),
        _: 1
      })
    ]),
    (isShowConfirmPaymentDialog.value)
      ? (_openBlock(), _createBlock(HjpCofirmModal, {
          key: 0,
          show: isShowConfirmPaymentDialog.value,
          title: confirmPaymentDialog.value?.title,
          subTitle: confirmPaymentDialog.value?.subTitle,
          btnSubmitTitle: confirmPaymentDialog.value?.btnSubmitTitle,
          subTitleHtml: confirmPaymentDialog.value?.subTitleHtml,
          imgContent: confirmPaymentDialog.value.imgContent,
          onHideDialog: hideConfirmPaymentDialog,
          onOnSubmit: submitFromPaymentDialog
        }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "subTitleHtml", "imgContent"]))
      : _createCommentVNode("", true),
    (isShowConfirmVerifyCheckerDialog.value)
      ? (_openBlock(), _createBlock(HjpCofirmModal, {
          key: 1,
          show: isShowConfirmVerifyCheckerDialog.value,
          title: confirmVerifyCheckerDialog.value?.title,
          subTitle: confirmVerifyCheckerDialog.value?.subTitle,
          subTitleHtml: confirmVerifyCheckerDialog.value?.subTitleHtml,
          btnSubmitTitle: confirmVerifyCheckerDialog.value?.btnSubmitTitle,
          imgContent: confirmVerifyCheckerDialog.value.imgContent,
          onHideDialog: hideConfirmVerifyCheckerDialog,
          onOnSubmit: checkerVerifyBatchAct
        }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]))
      : _createCommentVNode("", true),
    (isShowConfirmVerifyFinanceDialog.value)
      ? (_openBlock(), _createBlock(HjpCofirmModal, {
          key: 2,
          show: isShowConfirmVerifyFinanceDialog.value,
          title: confirmVerifyFinanceDialog.value?.title,
          subTitle: confirmVerifyFinanceDialog.value?.subTitle,
          subTitleHtml: confirmVerifyFinanceDialog.value?.subTitleHtml,
          btnSubmitTitle: confirmVerifyFinanceDialog.value?.btnSubmitTitle,
          imgContent: confirmVerifyFinanceDialog.value.imgContent,
          onHideDialog: hideConfirmVerifyFinanceDialog,
          onOnSubmit: financeVerifyBatchAct
        }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent"]))
      : _createCommentVNode("", true),
    _createVNode(HjpDefaultModal, {
      show: isShowDetailPaymentDialog.value,
      onHideDialog: hideDetailPaymentDialog,
      hasTitle: false,
      width: '75vw'
    }, {
      content: _withCtx(() => [
        (isShowDetailPaymentDialog.value)
          ? (_openBlock(), _createBlock(BatchPaymentDetail, {
              key: 0,
              data: headerData.value,
              onHideDialog: hideDetailPaymentDialog
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(DetailListActions, {
          confirm: _unref(origin) === 'checker' || _unref(origin) === 'finance',
          pending: _unref(origin) === 'checker' && _unref(selectedDetailRowData).TransactionType !== 'Refund',
          refund: _unref(origin) === 'finance',
          onConfirm: checkerConfirmAct,
          onPending: checkerPendingAct,
          onRefund: financeRefundAct
        }, null, 8, ["confirm", "pending", "refund"])
      ]),
      _: 1
    }, 512),
    _createVNode(HjpDefaultModal, {
      show: isShowCheckerPendingDialog.value,
      onHideDialog: hideCheckerPendingDialog,
      hasTitle: true
    }, {
      title: _withCtx(() => [
        _hoisted_80
      ]),
      content: _withCtx(() => [
        _createVNode(PendingPage, {
          onHideDialog: _cache[6] || (_cache[6] = ($event: any) => (hideCheckerPendingDialog())),
          onSubmit: checkerPendingSubmitAct,
          data: _unref(selectedRowData)
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(FinanceRefundForm, {
      isShow: isShowFinanceRefundForm.value,
      data: _unref(selectedDetailRowData),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (isShowFinanceRefundForm.value = false))
    }, null, 8, ["isShow", "data"])
  ], 64))
}
}

})